module.exports = __webpack_public_path__ + "media/images/team/max-4375b7edde6f9defe35be168c5ef9dab.jpg";